import {
  GET_RESTAURANT_GROUPS,
  GET_BRANDS_BY_GROUP,
  CREATE_BRAND,
  GET_BRAND_BY_ID,
  UPDATE_BRAND,
  GET_RESTAURANTS_BY_BRAND,
  ASSIGN_RESTAURANT_TO_BRAND,
  UPLOAD_BRAND_LOGO,
  DELETE_BRAND,
  UPDATE_BRAND_GIFT_CARDS_URL
} from '../constants/UriConstants';
import apiClient from './apiClient';

// ─── Restaurant Groups ──────────────────────────────────────────────────────

export const getRestaurantGroups = (): Promise<any[]> =>
  apiClient.get(GET_RESTAURANT_GROUPS).then((response) => response.data);

export const getRestaurantGroupByID = (restaurantGroupID: string): Promise<any> =>
  apiClient.get(`${GET_RESTAURANT_GROUPS}/${restaurantGroupID}`).then((response) => response.data);

// ─── Brands ──────────────────────────────────────────────────────────────────

export const createBrand = (restaurantGroupID: string, body: Record<string, unknown>): Promise<any> =>
  apiClient.post(CREATE_BRAND(restaurantGroupID), body).then((response) => response.data);

export const getBrandsByRestaurantGroupID = (restaurantGroupID: string): Promise<any[]> =>
  apiClient.get(GET_BRANDS_BY_GROUP(restaurantGroupID)).then((response) => response.data);

export const getBrandByID = (brandID: string): Promise<any> =>
  apiClient.get(GET_BRAND_BY_ID(brandID)).then((response) => response.data);

export const updateBrand = (brandID: string, body: Record<string, unknown>): Promise<any> =>
  apiClient.put(UPDATE_BRAND(brandID), body).then((response) => response.data);

export const getRestaurantsByBrandID = (brandID: string): Promise<any[]> =>
  apiClient.get(GET_RESTAURANTS_BY_BRAND(brandID)).then((response) => response.data);

export const assignRestaurantToBrand = (brandID: string, restaurantID: number): Promise<any> =>
  apiClient.put(ASSIGN_RESTAURANT_TO_BRAND(brandID, restaurantID)).then((response) => response.data);

export const uploadBrandLogo = (brandID: string, formData: FormData): Promise<any> =>
  apiClient.post(UPLOAD_BRAND_LOGO(brandID), formData).then((response) => response.data);

export const deleteBrand = (brandID: string): Promise<void> =>
  apiClient.delete(DELETE_BRAND(brandID)).then(() => undefined);

export const updateBrandGiftCardsUrl = (brandID: string, giftCardsUrl: string): Promise<void> =>
  apiClient.put(UPDATE_BRAND_GIFT_CARDS_URL(brandID), { giftCardsUrl }).then(() => undefined);
